import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { JeeSession1Service } from '../jee-session1.service';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { ColDef } from 'ag-grid-community';
import { take } from 'rxjs/operators';
import { JeeMainsRookieNotAppliedComponent } from '../jee-mains-rookie-not-applied/jee-mains-rookie-not-applied.component';

@Component({
  selector: 'app-jee-mains-session2-rookie-hlt-emtry',
  templateUrl: './jee-mains-session2-rookie-hlt-emtry.component.html',
  styleUrls: ['./jee-mains-session2-rookie-hlt-emtry.component.scss']
})
export class JeeMainsSession2RookieHltEmtryComponent implements OnInit {

  options: any[] = [];
    searchCriteria: string = '';
    currentDate: string;
    disabledFields: boolean = false;
    selectedAdmNo: string = '';
    selectedStudent: any = {};
    categoryList: any[] = [];
    selectedCategoryId: any = '';
    remarksDisabled: boolean = true;
  
    StudentName: any;
    parentName: any;
    cityName: any;
    campusName: any;
    examType: any;
    jeeMainsAppNo: any;
    studMobileNo: any;
    jeeMainsPassword: any;
    jeeMainsHtno: any;
    vitHtno: any;
    VitPassword: any
    studentEmail: any
    jeeFieldsDisabled: boolean = false;
  
    programName: any
    admNo: any
    mobileNo: any;
    rowData: any[];
    rowDataEntry: any[];
    remarks: any;
    gender: any;
    jeeMainsDisabled: boolean = false;
    isJeeNotApplied: boolean = false;
    // dialog: any;
  
  
    constructor(private jeemains: JeeSession1Service, private ngZone: NgZone, private dialog: NgDialogAnimationService,) {
      const today = new Date();
      this.currentDate = today.toLocaleDateString('en-GB'); // dd/MM/yyyy
    }
  
  ngOnInit(): void {
    console.log(this.searchCriteria);
    this.getJeeRookieEnteryData();
    this.getRookie2EnterdData();
    this.getCategoryDetails();
  }

formatHeader(key: string): string {
    return key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
  }
  search(): void {
    if (this.searchCriteria && this.searchCriteria.length > 6) {
      this.jeemains.getRookieAdmNo(this.searchCriteria).subscribe((res: any) => {
        this.options = res;
      });
    }
  }

  optionSelected(option: any, event: any): void {
    if (event.isUserInput) {
      this.searchCriteria = option.admNo; 
      this.getRookieStudentDetails(option.admNo); 
    }
  }


  getRookieStudentDetails(admNo: string): void {
    this.selectedAdmNo = admNo;
    this.jeemains.getRookieStudentList(admNo).subscribe((res: any) => {
      this.selectedStudent = res;
      this.StudentName = this.selectedStudent?.studentName;
      this.jeeMainsAppNo = this.selectedStudent?.jeeMainsApplicationNo;
      //this.disabledFields = !!this.jeeMainsAppNo;
      this.studMobileNo = this.selectedStudent?.mobileNo;
      //this.disabledFields = !!this.mobileNo;
      this.jeeMainsPassword = this.selectedStudent?.jeeMainsPassword;
      // this.disabledFields = !!this.jeeMainsPassword;
      this.jeeMainsHtno = this.selectedStudent?.jeeMainsHtno;
      //this.disabledFields = !!this.jeeMainsHtno;
      this.studentEmail = this.selectedStudent?.studentEmail;
      // this.disabledFields = !!this.studentEmail;
      this.categoryList = this.categoryList;
      this.remarksList = this.remarksList
      this.vitHtno = this.selectedStudent?.VitHtno;
      //this.disabledFields = !!this.vitHtno;
      this.VitPassword = this.selectedStudent?.VitPassword;
      //this.disabledFields = !!this.VitPassword;
      this.gender = this.selectedStudent.gender;
      this.parentName = this.selectedStudent.parentName;
      this.cityName = this.selectedStudent.cityName;
      this.campusName = this.selectedStudent.campusName;
      this.selectedCategoryId = this.selectedStudent?.categoryId ?? 0;
      this.examType = this.selectedStudent.examType;

      this.disabledFields =
        !!res.jeeMainsApplicationNo ||
        !!res.jeeMainsPassword ||
        !!res.jeeMainsHtno ||
        !!res.VitHtno ||
        !!res.VitPassword;

      console.log('Student Details:', res);
      //this.clearJeeCheck();

    });
  }

   remarksList: string[] = [
    'Under Age',
    'Long Absent',
    'Health Issue',
    'First Year Backlog',
    'Interested in EAMCET or other courses'
  ];


  examTypes: string = 'ONLINE';

  getCategoryDetails(): void {
    this.jeemains.getCategoryList().subscribe((res: any[]) => {
      this.categoryList = res;
      console.log('Category List:', res);
    });
  }

   onNumericInput(event: any, fieldName: 'studMobileNo' | 'jeeMainsAppNo' | 'vitHtno'): void {
      const input = event.target.value.replace(/[^0-9]/g, '');
      event.target.value = input;
      (this as any)[fieldName] = input;
    }
  
    onInputField(event: Event): void {
      const inputValue = (event.target as HTMLInputElement).value;
  
      // Disable if input is filled with bound data (length check or specific value match)
      if (inputValue != null && inputValue === this.selectedStudent?.jeeMainsApplicationNo) {
        this.disabledFields = true;
      } else {
        this.disabledFields = false;
      }
  
      if (inputValue != null && inputValue === this.selectedStudent?.jeeMainsApplicationNo) {
        this.disabledFields = true;
      } else {
        this.disabledFields = false;
      }
  
      if (inputValue != null && inputValue === this.selectedStudent?.mobileNo) {
        this.disabledFields = true;
      } else {
        this.disabledFields = false;
      }
  
      if (inputValue != null && inputValue === this.selectedStudent?.jeeMainsPassword) {
        this.disabledFields = true;
      } else {
        this.disabledFields = false;
      }
  
      if (inputValue != null && inputValue === this.selectedStudent?.jeeMainsHtno) {
        this.disabledFields = true;
      } else {
        this.disabledFields = false;
      }
  
      if (inputValue != null && inputValue === this.selectedStudent?.studentEmail) {
        this.disabledFields = true;
      } else {
        this.disabledFields = false;
      }
  
      if (inputValue != null && inputValue === this.selectedStudent?.VitHtno) {
        this.disabledFields = true;
      } else {
        this.disabledFields = false;
      }
  
      if (inputValue != null && inputValue === this.selectedStudent?.VitPassword) {
        this.disabledFields = true;
      } else {
        this.disabledFields = false;
      }
  
    }
  
    clearJeeFields() {
      if (this.isJeeNotApplied) {
        //  Checkbox checked — clear and disable
        this.jeeMainsAppNo = '';
        this.studMobileNo = '';
        this.jeeMainsPassword = '';
        this.jeeFieldsDisabled = true;
      } else {
        //  Checkbox unchecked — enable fields again
        this.jeeFieldsDisabled = false;
        this.remarks = '';
      }
    }
  
    // @ViewChild('searchCriteriaInput') searchCriteriaInput!: ElementRef<HTMLInputElement>;
    @ViewChild('jeeHtnoInput') jeeHtnoInput!: ElementRef<HTMLInputElement>;
    @ViewChild('jeeMainsAppNoInput') jeeMainsAppNoInput!: ElementRef<HTMLInputElement>;
    @ViewChild('studentEmailInput') studentEmailInput!: ElementRef<HTMLInputElement>;
    @ViewChild('selectedCategoryIdInput') selectedCategoryIdInput!: ElementRef<HTMLInputElement>;
    @ViewChild('examTypeInput') examTypeInput!: ElementRef<HTMLInputElement>;
    @ViewChild('studMobileNoInput') studMobileNoInput!: ElementRef<HTMLInputElement>;
    @ViewChild('jeeMainsPasswordInput') jeeMainsPasswordInput!: ElementRef<HTMLInputElement>;
    @ViewChild('vitHtnoInput') vitHtnoInput!: ElementRef<HTMLInputElement>;
    @ViewChild('VitPasswordInput') VitPasswordInput!: ElementRef<HTMLInputElement>;
    @ViewChild('searchCriteriaInput') searchCriteriaInput!: ElementRef<HTMLInputElement>;
    @ViewChild('pageContainer') pageContainer!: ElementRef;
  
  
    @ViewChild('jeeCheck') jeeCheck!: ElementRef<HTMLInputElement>;
    clearForm() {
      this.searchCriteria = '';
      this.studentEmail = '';
      this.examType = '';
      this.jeeMainsAppNo = '';
      this.jeeMainsPassword = '';
      this.jeeMainsHtno = '';
      this.vitHtno = '';
      this.VitPassword = '';
      this.studMobileNo = '';
      this.selectedCategoryId = '0';
      this.remarks = '';
      this.jeeCheck.nativeElement.checked = false;
      this.isJeeNotApplied = false;
      this.StudentName = '';
      this.parentName = '';
      this.cityName = '';
      this.campusName = '';
      this.selectedStudent = {} as any;
    }
  
    clearJeeCheck() {
      this.jeeCheck.nativeElement.checked = false;
    }

 submitForm() {
    if (!this.searchCriteria) {
      if (!this.searchCriteriaInput.nativeElement.value) {
        alert('Please enter Admission Number');
        setTimeout(() => {
          this.searchCriteriaInput.nativeElement.focus();
        });
        return;
      }
    }

    if (!this.studentEmail) {
      if (!this.studentEmailInput.nativeElement.value) {
        alert('Please Enter Student Email');
        setTimeout(() => {
          this.studentEmailInput.nativeElement.focus();
        });
        return;
      }
    }

    if (!this.selectedCategoryId) {
      alert('Please select category');
      // Focus the mat-select component
      setTimeout(() => {
        this.selectedCategoryIdInput.nativeElement.focus();
      });
      return;
    }


    if (!this.isJeeNotApplied) {
      // if (!this.examType) {
      //   if (!this.examTypeInput.nativeElement.value) {
      //     alert('Please select Exam Type');
      //     setTimeout(() => {
      //       this.examTypeInput.nativeElement.focus();
      //     });
      //     return;
      //   }
      // }

      if (!this.jeeMainsAppNo) {
        if (!this.jeeMainsAppNoInput.nativeElement.value) {
          alert('Please enter Jee Mains Application Number');
          setTimeout(() => {
            this.jeeMainsAppNoInput.nativeElement.focus();
          });
          return;
        }
      }

      if (this.jeeMainsAppNo.length < 12) {
        alert('JEE-MAINS Application Number must be 12 digit number');
        setTimeout(() => {
          this.jeeMainsAppNoInput.nativeElement.focus();
        });
        return;
      }

      if (!this.studMobileNo) {
        if (!this.studMobileNoInput.nativeElement.value) {
          alert('Please enter Mobile Number');
          setTimeout(() => {
            this.studMobileNoInput.nativeElement.focus();
          });
          return;
        }
      }

      if (this.studMobileNo.length < 10) {
        alert('Mobile Number must be 10 digit number');
        setTimeout(() => {
          this.studMobileNoInput.nativeElement.focus();
        });
        return;
      }

      if (!this.jeeMainsPassword) {
        if (!this.jeeMainsPasswordInput.nativeElement.value) {
          alert('Please enter Jee Mains Password');
          setTimeout(() => {
            this.jeeMainsPasswordInput.nativeElement.focus();
          });
          return;
        }
      }

      const jeeHtnoStr = this.jeeMainsHtno ? String(this.jeeMainsHtno).trim() : '';
      if (jeeHtnoStr && jeeHtnoStr.length < 8) {
        alert("JEE-MAINS Hall Ticket Number must be at least 8 digits");
        setTimeout(() => {
          this.jeeHtnoInput.nativeElement.focus();
        });
        return;
      }

    }

    if (confirm("Do you want to save?")) {
      const rookieStudentData = {
        admNo: this.searchCriteria,
        studentEmail: this.studentEmail,
        examType: this.examType,
        jeeMainsApplicationNo: this.jeeMainsAppNo,
        jeeMainsPassword: this.jeeMainsPassword,
        jeeMainsHtno: this.jeeMainsHtno,
        mainsSession: 'RookieJeeMainsSession2',
        mobileNo: this.studMobileNo,
        appliedStatus: '',
        categoryId: this.selectedCategoryId,
        remarks: this.remarks,
        gender: this.gender,
        StudentName: this.StudentName,
        parentName: this.parentName,
        cityName: this.cityName,
        campusName: this.campusName,

      };

      console.log('rookieStudentData', rookieStudentData);

      this.jeemains.createRookieStudent(rookieStudentData).subscribe({
        next: (response) => {
          console.log('Success:', response);
          let resObj;
          try {
            resObj = typeof response === 'string' ? JSON.parse(response) : response;
          } catch (e) {
            resObj = response;
          }

          if (resObj.status === 'OK') {
            alert(resObj.message);
            this.clearForm();
           // this.getRookieEnterdData();
            //this.getJeeRookieEnteryData();
          } else {
            alert(resObj.message);
          }
        },
        error: (error) => {
          console.error('Error:', error);
          alert('Error saving student.');
        }
      });
    } else {
      console.log("Save cancelled by user.");
    }
  }

 columnDefs: ColDef[] = [
    {
      headerName: 'Edit',
      field: 'edit',
      cellRenderer: (params: any) => {
        return `<a style="color:#007BFF; font-weight:bold; cursor:pointer;">Edit</a>`;
      },
      onCellClicked: (params: any) => {
        if (params.data?.admNo) {
          this.onEditClick(params.data.admNo); // directly call component method
        }
      },
      cellStyle: { textAlign: 'center' },
      width: 100
    },



    { headerName: 'AddmissionNo', field: 'admNo', cellStyle: { textAlign: 'left' }, },
    { headerName: 'StudentName', field: 'studentName', cellStyle: { textAlign: 'left' }, },
    { headerName: 'PrentName', field: 'prentName', cellStyle: { textAlign: 'left' }, },
    { headerName: 'JeeMainsAppNo', field: 'jeeMainsAppNo' },
    { headerName: 'JeeMAinsHtNo', field: 'jeeMAinsHtNo' },
    { headerName: 'PasswordStatus', field: 'passwordStatus' }

  ];

   defaultColDef = {
    // width: 150,
    flex: 1,
    cellStyle: {
      fontFamily: 'medium', textAlign: 'right'
    },
    headerStyle: { fontWeight: 'bold', background: '#0564B1', color: 'white' }
  };

  onEditClick(admNo: string): void {
    this.searchCriteria = admNo;
    this.getRookieStudentDetails(this.searchCriteria);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 200);
  }

  getRookie2EnterdData(): void {
    this.jeemains.getRookie2EnteredDta().subscribe((data) => {
      console.log(data)
      this.rowData = data;
    });
  }


  columnDefsEntry: ColDef[] = [
    {
      headerName: 'Program',
      field: 'program',
      cellStyle: { textAlign: 'left' },
    },

    { headerName: 'Total', field: 'total' },
    { headerName: 'JeeMains2Applied', field: 'jeeMains2Applied' },
    {
      headerName: 'JeeMains2NotApplied', field: 'jeeMains2NotApplied',
    },
    {
      headerName: 'JeeMains2NotEntered', field: 'jeenotEntered', cellStyle: { color: '#fb4700ff', cursor: 'pointer' },
    },
    { headerName: 'Valid', field: 'valid' },
    { headerName: 'Invalid', field: 'Invalid' },
    { headerName: 'NotVerified', field: 'notVerified' },

  ];

  getJeeRookieEnteryData(): void {
    this.jeemains.getJeeRookie2EntereyDta().subscribe((data) => {
      console.log(data)
      this.rowDataEntry = data;
    });
  }

getJeeMainsRookieNotAppliedClick(data: any) {

  const dialogRef = this.dialog.open(JeeMainsRookieNotAppliedComponent,
    {
      direction: 'ltr',
      height: '100%',
      width: '45%',
      data: data,
      position: { right: '0px', top: '0px' }
    }
  );

  dialogRef.afterClosed().pipe(take(1)).subscribe((result: any) => {
    console.log('Rookie dialog result =', result);
    if (result?.admNo) {
      this.ngZone.run(() => { 
        this.searchCriteria = result.admNo;
        this.getRookieStudentDetails(result.admNo); 
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          if (this.searchCriteriaInput?.nativeElement) {
            const inputEl = this.searchCriteriaInput.nativeElement as HTMLInputElement;
            inputEl.focus();
            inputEl.select();
          }
        }, 100);

      });
    }
  });

  this.isJeeNotApplied = false;
}



   onCellClicked(event: any) {
    if (event.colDef.field === 'jeenotEntered') {
      this.getJeeMainsRookieNotAppliedClick(event.data);  // send row data if needed
    }
  }


}
